import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";

interface BuildInfoProps {
  commitHash: string;
  nodeEnv: string;
  backendUrl: string;
}

const BuildInfo: React.FC<BuildInfoProps> = ({
  commitHash,
  nodeEnv,
  backendUrl,
}) => {
  return (
    <Row>
      <Col md={4}>
        <BlockyMediumText style={{ color: "#666" }}>Commit Hash:</BlockyMediumText>
        <BlockyHeavyText style={{ fontFamily: "monospace", color: "#007bff" }}>
          {commitHash}
        </BlockyHeavyText>
      </Col>
      <Col md={4}>
        <BlockyMediumText style={{ color: "#666" }}>Environment:</BlockyMediumText>
        <Badge bg={nodeEnv === "production" ? "success" : "warning"}>
          {nodeEnv}
        </Badge>
      </Col>
      <Col md={4}>
        <BlockyMediumText style={{ color: "#666" }}>Backend URL:</BlockyMediumText>
        <BlockyHeavyText style={{ fontSize: "12px", wordBreak: "break-all" }}>
          {backendUrl}
        </BlockyHeavyText>
      </Col>
    </Row>
  );
};

export default BuildInfo;